export default __webpack_public_path__ + "static/media/Ripple.25989aad.svg";